<template lang="html" >
  <div id="app" @mousemove="verificarActividad()">
    <ModalCargando v-if="modalCargando" />
    <RevisarInternet />
    <b-modal
      v-model="modalAviso"
      :centered="true"
      hide-footer
      hide-header
      size="lg"
      id="modalCargandoGeneral"
    >
    <button @click="modalAviso = false" class="close"><i class="fa fa-times"></i></button>
      <img src="@/assets/images/pixan1_5.png" class="img-fluid"><br>
    </b-modal>

    <b-modal
      v-model="modalSucursalInactiva"
      :centered="true"
      hide-footer
      hide-header
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <center>
        <br>
        <i style="font-size: 77px !important; color: #ff5722;" class="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i> 
        <br><br><br><br><br>
        <h4 style="margin-top: -55px;">Está sucursal esta inactiva, cambia de sucursal o informa al administrador.</h4>
        <br>
        <b-button @click="forzarCerrarSesion">Cerrar sesión</b-button>
        <b-button @click="$router.push('/franquicia-cambio');">Cambiar sucursal</b-button>
      </center>
    </b-modal>


    <router-view></router-view>
  </div>
</template>

<script lang="js">

var baseUrl = window.location.origin;
import firebase from '@/firebase'
import { mapState, mapGetters, mapActions } from "vuex";
import {STATUS_APP} from '@/constantes/usuarios.js'
import {ADMIN_MASTER_ID} from '@/constantes/panel_roles.js'
import $ from 'jquery'
import Vue from 'vue'
import moment from "moment";
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)


export default {
  components:{
    ModalCargando: () => import("@/componentes/cargando/modalCargando"),
    RevisarInternet: () => import("@/components/RevisarInternet"),
  },
  data () {
    return {
      timeout: '',
      contadorCargando: 1,
      modalCargando: true,
      modalSucursalInactiva: false,
      pathsInicio: ['/login','/cargando','/registrarse','/'],
      modalAviso: false,
    }
  },
  computed: {
    ...mapGetters(['statusApp', 'usuario', 'usuario_token', 'franquicia', 'rolHeader', 'sucursalActual', 'corporativoinfo', 'loading_aviso']),
    
    
  },
  watch: {
    /*statusApp () {
      //console.log('status app cambiado: '+this.statusApp)
      this.revisarStatusApp()
    },*/
    'rolHeader'(){
      //console.log("TCL: WATCH -> rolHeader", this.rolHeader)
      if(this.rolHeader){
        this.revisarStatusApp()
      }
    },
    'loading_aviso'(){
      //console.log("TCL: WATCH -> rolHeader", this.rolHeader)
      if(this.loading_aviso){
        this.modalAviso = true;
      }else{
        this.modalAviso = false;
      }
    },
    '$route.name'(){
      //Verificar que la sucursal este activa
      this.verificarSucursal();

      //console.log("TCL: WATCH -> route", this.rolHeader.info)
      if(this.$route.name !== 'franquicia-cambio'){
        if(this.usuario){
          this.checarSuscripcionSucursal();

          this.validarSuscripcion();
        }
      }
      
      
      if(this.rolHeader.info){
        //console.log('TCL: ROUTE PATH :',this.$route.name)
        let permisoUrl = this.checarAccesoAUrl(this.$route.name);
        //console.log('TCL: PermisoUrl:',permisoUrl)
        if(!permisoUrl){
          const routeName = this.redirigirLogin(this.rolHeader);
          if(routeName){
              this.$router.push(this.redirigirLogin(this.rolHeader))
          }
          
        }
        
      }
    },
    "franquicia": function (val) {
      if(this.franquicia.id && this.usuario){
        if(this.usuario.id_franquicia){
          this.cargaIndiceSucursales(this.usuario.id_franquicia);
        }else{
          if(this.usuario.franquicia){ //para empleado
            this.cargaIndiceSucursales(this.usuario.franquicia);
          }
        }
        
        this.cargaIndiceUsuarios(); 
        if(this.usuario.id_corporativo){
          this.cargaInfoCorporativoGet(this.usuario.id_corporativo);
        }
        if(this.usuario.info.cargo){
          this.cargarRolHeader(this.usuario.info.cargo);
        }
        if(this.usuario.info.rol || this.usuario.id === ADMIN_MASTER_ID){
          this.cargarPanelRolHeader(this.usuario.info.rol);
        }

      }
    },
    "sucursalActual": function (val) {
      //Verificar que la sucursal este activa
      if(this.sucursalActual){
        this.verificarSucursal();
      }
    },
    "usuario": function (val) {

      if(this.franquicia.id && this.usuario){
          // //console.log("TCL: watch -> this.usuario", this.usuario.info_complementaria.token_dispositivo)
          // //console.log("TCL: watch -> localStorage.token_dispositivo", localStorage.token_dispositivo)
          if(!this.usuario.tipo){
            if(this.usuario.info_complementaria.token_dispositivo !== null){
              if(this.usuario.info_complementaria.token_dispositivo !== localStorage.token_dispositivo){
                localStorage.flagLogin = 1;
                this.desconectarse().then(result => {
                  console.log("TCL: result deslogueo", result)
                  console.log('TCL: >>TOKEN INCORRECTO')
                  //window.location.href = baseUrl;
                });
              }
            }
          }


          
          
        
          
      }

    },
  },
  methods: {
    ...mapActions([
      'desconectarse', 
      'cargaInicialUsuario',
      'cambiaStatusApp', 
      'cargaIndiceUsuarios', 
      'cargarRolHeader', 
      'cargarPanelRolHeader', 
      'cargaIndiceSucursales', 
      'cargaInfoCorporativoGet', 
      'cargaSucursal',
      'actualizarUsuario','actualizaCorporativo']),
    revisarStatusApp() {
        // console.log("TCL: revisarStatusApp -> window.inicialPath", window.inicialPath)
        let permisoUrl = this.checarAccesoAUrl(this.$route.name);
  
        if (this.statusApp === STATUS_APP.ACTIVA) {

          //Si es usuario hardcode redirige al panel de control
          if(this.usuario.id == 'DzFeyylmESMWe8oCRal51vs9Tzt2'){
            console.log('PANEL REDIREC');
            this.$router.push('/panel')
          }else{
            if(this.pathsInicio.includes(window.inicialPath)){
              //this.$router.push('/blank_page')
              this.$router.push('/home')
            } else {
              // console.log("TCL: permisoUrl",permisoUrl)
              if(!permisoUrl){
                this.$router.push(this.redirigirLogin(this.rolHeader))
              }else{
                this.$router.push(window.inicialPath)
              }
              
            }
          }

          
        
      }
    },
    verificarActividad(){
      /* ESTE CODIGO ES PARA REINICIAR EL TIEMPO DE LA EXPIRACION DEL TOKEN  */
      if(this.modalCargando == false){
        //console.log('TCL: ENTRA A VERIFICAR ACTIVIDAD')
        const currentTime = new Date().getTime();
        localStorage.setItem("accepted", currentTime);
      }
      /* FIN ESTE CODIGO ES PARA REINICIAR EL TIEMPO DE LA EXPIRACION DEL TOKEN  */

      // //console.log("TCL: timeout -> Start again")
      var tiempoL = this.$cookies.get('timerlogin');
      clearTimeout(tiempoL)
      //console.log("TCL: 1verificarActividad -> tiempoL", tiempoL)
      tiempoL = setTimeout(() => {
        //Log out  user
        // console.log("TCL: timeout -> Log out the user")
        if(tiempoL == this.$cookies.get('timerlogin')){
          localStorage.flagLogin = 1;
          this.desconectarse().then(result => {
            //window.location.href = baseUrl;
          });
        }
        
      //}, 800)
      }, 20 * 60 * 1000)
      this.$cookies.set('timerlogin',tiempoL);
    },
    checarSuscripcionSucursal(){
      //Inicio validar sucursal
        this.axios.get(`https://app.pixancloud.com/ws/pagos/sucursales/get_sucursales.php?id_sucursal=${this.usuario.sucursal_actual}`)
        .then(response => {
          console.log("TCL: obtenerSuscripciones -> response", response)
          if(response.data.mensaje !== false){

            var currentDate = moment(response.data.mensaje.fecha_expiracion);
           
            var fechaExpiracion = moment(currentDate);
            if(moment().unix() > fechaExpiracion.unix()){
              console.log("TCL: La suscripcion de la sucursal ha caducado");
              this.$router.push('/sucursal_restringido')
            }else{
              console.log("TCL: La suscripcion de la sucursal aun es valida");
            }

          
          }
        })
        .catch(e => {
          console.log(e);
        })

        //Fin validar sucursal
    },


    validarSuscripcion(){
      //console.log('TCL: validarSuscripcion -> corportarivo create -> ', this.corporativoinfo);
      //console.log("TCL: validarSuscripcion -> created -> this.usuario.rol", this.usuario.rol)
      
      if(this.usuario.rol == 'Admin'){
        console.log('TCL: pago 001');
        if(this.usuario.estatus_pago.fecha_pago == null && this.$route.name !== 'pago_completado'){
          console.log('TCL: Created - Check para redirigir ');
          if(this.usuario.estatus_pago.estatus !== null){
            this.$router.push({ name: "validando_pago" });
          }else{
            this.$router.push({ name: "suscripcion" });
          }
        }else{
          console.log('TCL: pago 002');
          let vuData  = this;
            if(this.usuario.estatus_pago.id_suscripcion == null){
                console.log('TCL: pago 003');
                console.log(`TCL: CHECANDO BASE DE DATOS POR ID USER ?id_usuario=${vuData.usuario.id}`)

                vuData.axios.get(`https://app.pixancloud.com/ws/pagos/planes/get_pagos.php?id_usuario=${vuData.usuario.id}`)
                .then(response => {
                    if(response.data.mensaje !== false){
                      console.log('response: ',response.data.mensaje);

                      if(response.data.mensaje.txn_type == 'subscr_cancel'){
                        vuData.usuario.estatus_pago.recurrente = false;
                      }else{
                        vuData.usuario.estatus_pago.fecha_pago = new Date (response.data.mensaje.fecha_expiracion)
                        vuData.usuario.estatus_pago.id_suscripcion = response.data.mensaje.subscr_id
                        vuData.usuario.estatus_pago.plan = response.data.mensaje.item_number
                        vuData.usuario.estatus_pago.estatus = null
                        vuData.usuario.estatus_pago.ya_uso_premium = true
                        if(response.data.mensaje.item_number == '001'){
                          vuData.usuario.estatus_pago.ya_uso_premium = false
                        }

                        vuData.usuario.estatus_pago.recurrente = true;
                      }
                      vuData.actualizarUsuario(vuData.usuario)

                      
                      const unixTimeExpiracion = vuData.usuario.estatus_pago.fecha_pago.getTime()/1000;
                      //var currentDate = moment.unix(unixTimeExpiracion);
                      

                      //var fechaExpiracion = moment(currentDate);
                      if(moment().unix() > unixTimeExpiracion){
                        console.log("TCL: La suscripcion ha caducado 1");
                        vuData.modalRenovacion = true;

                        //actualizar el estado del corporativo
                        if(vuData.corporativoinfo.id){
                          console.log("TCL: validarSuscripcion -> vuData.corporativoinfo", vuData.corporativoinfo)
                          vuData.corporativoinfo.estatus_pago = false
                          vuData.actualizaCorporativo(vuData.corporativoinfo);
                        }
                        

                        vuData.$router.push({ name: "suscripcion" });
                      }else{
                        console.log("TCL: La suscripcion aun es valida");
                        vuData.modalRenovacion = false;
                        vuData.modalCargandoCaracteristicas = false;

                        //actualizar el estado del corporativo
                        if(vuData.corporativoinfo.id){
                          console.log("TCL: validarSuscripcion -> vuData.corporativoinfo", vuData.corporativoinfo)
                          vuData.corporativoinfo.estatus_pago = true
                          vuData.actualizaCorporativo(vuData.corporativoinfo);
                        }
                        

                        if(vuData.$route.name == 'pago_completado'){
                          vuData.$router.push({ name: "propietarios" });
                        }
                        
                        
                      }


                    }
                })
                .catch(e => {
                    console.log(e);
                })
             
            }// Fin sino tiene un id de suscripcion
            else{
                console.log('TCL: pago 004');
                console.log('TCL: CHECANDO BASE DE DATOS CON ID SUSCRIPCION')
                vuData.axios.get(`https://app.pixancloud.com/ws/pagos/planes/get_pagos.php?id_usuario=${vuData.usuario.id}`)
                .then(response => {
                    if(response.data.mensaje !== false){
                      console.log('response: ',response.data.mensaje);
                      
                      if(response.data.mensaje.txn_type == 'subscr_cancel'){
                        vuData.usuario.estatus_pago.recurrente = false;
                      }else{
                        vuData.usuario.estatus_pago.fecha_pago = new Date (response.data.mensaje.fecha_expiracion)
                        vuData.usuario.estatus_pago.id_suscripcion = response.data.mensaje.subscr_id
                        vuData.usuario.estatus_pago.recurrente = true;
                        vuData.usuario.estatus_pago.estatus = null
                        vuData.usuario.estatus_pago.ya_uso_premium = true
                        if(response.data.mensaje.item_number){
                          vuData.usuario.estatus_pago.plan = response.data.mensaje.item_number
                        }
                        if(response.data.mensaje.item_number == '001'){
                          vuData.usuario.estatus_pago.ya_uso_premium = false
                        }
                        if(response.data.mensaje.mc_currency){
                          vuData.usuario.estatus_pago.recurrente = true
                        }else{
                          vuData.usuario.estatus_pago.recurrente = false
                        }
                      }
                      vuData.actualizarUsuario(vuData.usuario)

                      const unixTimeExpiracion = vuData.usuario.estatus_pago.fecha_pago.getTime()/1000;
                      console.log("🚀 ~ file: App.vue ~ unixTimeExpiracion ", unixTimeExpiracion)
                      //var currentDate = moment.unix(vuData.usuario.estatus_pago.fecha_pago.seconds);
                      var currentDate = unixTimeExpiracion;

                      //var fechaExpiracion = moment(currentDate);
                      if(moment().unix() > currentDate){
                        console.log("TCL: La suscripcion ha caducado 2");
                        vuData.modalRenovacion = true;

                        //actualizar el estado del corporativo
                        if(vuData.corporativoinfo.id){
                          console.log("TCL: validarSuscripcion -> vuData.corporativoinfo", vuData.corporativoinfo)
                          vuData.corporativoinfo.estatus_pago = false
                          vuData.actualizaCorporativo(vuData.corporativoinfo);
                        }
                        

                        vuData.$router.push({ name: "suscripcion" });
                      }else{
                        console.log("TCL: La suscripcion aun es valida");
                        vuData.modalRenovacion = false;
                        vuData.modalCargandoCaracteristicas = false;

                        //actualizar el estado del corporativo
                        if(vuData.corporativoinfo.id){
                          console.log("TCL: validarSuscripcion -> vuData.corporativoinfo", vuData.corporativoinfo)
                          vuData.corporativoinfo.estatus_pago = true
                          vuData.actualizaCorporativo(vuData.corporativoinfo);
                        }
                        


                        if(vuData.$route.name == 'pago_completado'){
                          vuData.$router.push({ name: "propietarios" });
                        }

                      }


                    }
                })
                .catch(e => {
                    console.log(e);
                })
             
            }

        }// fin else si no es null la fecha
      }//Fin solo si es ADMIN (el que registro)
      else{
        console.log("TCL: validarSuscripcion -> this.corporativoinfo", this.corporativoinfo)
          
        if(this.corporativoinfo){
          if(this.corporativoinfo.estatus_pago !== undefined){
            if(this.corporativoinfo.estatus_pago == false){
              console.log('Restringido corporativo 23:  ', this.corporativoinfo)
              this.$router.push('/restringido')
            }
          }
        }
      }
    },






    checarAccesoAUrl(nombre){
      //console.log("TCL: checarAccesoAUrl -> nombre", nombre)
      let status = true
      if((nombre == "paciente_nuevo_con_propietario" 
      || nombre == "propietarios" 
      || nombre == "propietario"
      || nombre == "propietarioNuevo"
      || nombre == "saldo") && !this.rolHeader.modulos.propietarios.accesos){
        status = false
      }if((nombre == "paciente_nuevo" 
      || nombre == "paciente_editar" 
      || nombre == "pacientes" 
      || nombre == "plan_bienestar_paciente" 
      || nombre == "Casos" 
      || nombre == "ServiciosCasos") && !this.rolHeader.modulos.pacientes.accesos){
        status = false
      }if(nombre == "CasosGeneral" && !this.rolHeader.modulos.pacientes.casos.consultar){
        status = false
      }if(nombre == "agenda" && !this.rolHeader.modulos.agenda.accesos){
        status = false
      }if(nombre == "cortes_caja" && !this.rolHeader.modulos.cortes_caja.accesos){
        status = false
      }if(nombre == "descuentos" && !this.rolHeader.modulos.descuentos.accesos){
        status = false
      }if(nombre == "planes_bienestar" && !this.rolHeader.modulos.planes_bienestar.accesos){
        status = false
      }if((nombre == "Corporativo" 
      || nombre == "Corporativo_info" 
      || nombre == "Sucursales" 
      || nombre == "Sucursal" 
      || nombre == "SucursalNuevo") && !this.rolHeader.modulos.corporativo.accesos){
        status = false
      }if((nombre == "usuarios"
      || nombre == "usuario" 
      || nombre == "usuarioNuevo") && !this.rolHeader.modulos.usuarios.accesos){
        status = false
      }if((nombre == "roles"
      || nombre == "rol_nuevo" 
      || nombre == "rol_editar") && !this.rolHeader.modulos.roles.accesos){
        status = false
      }if(nombre == "reportes" && !this.rolHeader.modulos.reportes.accesos){
        status = false
      }if(nombre == "Productos" && !this.rolHeader.modulos.catalogos.accesos){
        status = false
      }
      return status;
    },
    redirigirLogin(rolHeader){
      // console.log("TCL: redirigirLogin -> rolHeader", rolHeader)
      
      if(rolHeader.modulos.propietarios.accesos){
        return '/propietarios'
      }if(rolHeader.modulos.pacientes.accesos){
        return '/pacientes'
      }if(rolHeader.modulos.pacientes.casos.consultar){
        return '/casos'
      }if(rolHeader.modulos.agenda.accesos){
        return '/agenda'
      }if(rolHeader.modulos.cortes_caja.accesos){
        return '/cortes_caja'
      }if(rolHeader.modulos.descuentos.accesos){
        return '/descuentos'
      }if(rolHeader.modulos.planes_bienestar.accesos){
        return '/planes_bienestar'
      }if(rolHeader.modulos.corporativo.accesos){
        return '/corporativo'
      }if(rolHeader.modulos.usuarios.accesos){
        return '/usuarios'
      }if(rolHeader.modulos.roles.accesos){
        return '/roles'
      }if(rolHeader.modulos.reportes.accesos){
        return '/reportes'
      }if(rolHeader.modulos.catalogos.accesos){
        return '/Productos'
      }
    },
    forzarCerrarSesion() {
      localStorage.flagLogin = 1;
      this.desconectarse().then(result => {
        //window.location.href = baseUrl;
      });
    },
    verificarSucursal(){
      if(this.sucursalActual){
        this.cargaSucursal(this.sucursalActual).then(result => {
        console.log("TCL: verificarSucursal -> result", result)
        if(result.info.estatus == 'activo' || result.info.estatus == undefined || result.info.estatus == null){
          this.modalSucursalInactiva = false;
        }else{
          this.modalSucursalInactiva = true;
        }

        if(this.$route.name == 'franquicia-cambio'){
          this.modalSucursalInactiva = false;
        }
        
      });
      }
      

    }
    
  }, // sin de metodos
  created() {
    console.log('TCL: CREATED APP.VUE')
    localStorage.removeItem('flagLogin');
    //cargamos los colores al store desde BDD Firestore
    if(this.franquicia.id && this.usuario){
      this.cargaIndiceSucursales(this.usuario.id_franquicia);
      this.cargaIndiceUsuarios();

      if(this.usuario.info.cargo){
        this.cargarRolHeader(this.usuario.info.cargo);
      }
      if(this.usuario.info.rol || this.usuario.id === ADMIN_MASTER_ID){
        this.cargarPanelRolHeader(this.usuario.info.rol);
      }


      this.cargaInfoCorporativoGet(this.usuario.id_corporativo);

      
      console.log('TCL: PRIMER CREATED APP.VUE')
      
    }
  },
  mounted () {
    //window.purechatApi = { l: [], t: [], on: function () { this.l.push(arguments); } }; (function () { var done = false; var script = document.createElement('script'); script.async = true; script.type = 'text/javascript'; script.src = 'https://app.purechat.com/VisitorWidget/WidgetScript'; document.getElementsByTagName('HEAD').item(0).appendChild(script); script.onreadystatechange = script.onload = function (e) { if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) { var w = new PCWidget({c: '8763404f-f053-4b0d-8adc-7fed9881990d', f: true }); done = true; } }; })();
    if (navigator.appVersion.indexOf("Win")!=-1) 
    {
      console.log('WINDOWS')
      $('body').addClass('windows');
     // $('.tooltip .arrow:before').css({'left':'50%', 'margin-left' : '65%'});
    } 
    //console.log('mounted: ', this.$route)
    //console.log(this.$route)
    
    /* let user = firebase.auth().currentUser
   
    if (user) {
      this.$store.dispatch('cargaInicialUsuario',user.uid)
    } */
    
     //this.cambiaStatusApp(STATUS_APP.INICIAL)
  },
  beforeCreate(){
    //console.log('beforeCreate: ', this.$route)
    //console.log(this.$router)
    //console.log('window.inicialPath')
    //console.log(window.inicialPath)
    //this.$router.push('/inicio')

    firebase.auth().onAuthStateChanged((user)=>{
      //console.log('onAuthStateChanged')
      console.log('user')
      console.log(user)
      

      if (user) {
        localStorage.flagLogin = 1;
        this.$store.dispatch('cargaInicialUsuario',user.uid).then(()=>{

          //Si es usuario hardcode redirige al panel de control
          if(user.uid == 'DzFeyylmESMWe8oCRal51vs9Tzt2'){
            console.log('PANEL REDIREC');
            this.$router.push('/panel')
          }else{
            if(this.pathsInicio.includes(window.inicialPath)){
              this.$router.push('/home')
            } else {
              this.$router.push(window.inicialPath)
            }
          }
          this.modalCargando = false;

          

        })
      }else{
        console.log('USER ES NULL')
         this.modalCargando = true;
         //this.$router.push('/login')
         console.log("TCL: this.contadorCargando", localStorage.flagLogin)
         if(localStorage.flagLogin !== undefined){
           this.modalCargando = true;
           //window.location.href = baseUrl;
           setTimeout(function() { window.location.href = baseUrl; }, 3000);
         }else{
           this.$router.push('/login')
           localStorage.flagLogin = 1;
           this.modalCargando = false;
         }
         
      }

    })
    
  }
}
</script>

<style>
@import "../node_modules/mdi/css/materialdesignicons.min.css";
@import "../node_modules/bootstrap-vue/dist/bootstrap-vue.min.css";
@import "../node_modules/flag-icon-css/css/flag-icon.min.css";
@import "../node_modules/font-awesome/css/font-awesome.min.css";
@import "../node_modules/simple-line-icons/css/simple-line-icons.css";
@import "../node_modules/ti-icons/css/themify-icons.css";
@import "../node_modules/fullcalendar/dist/fullcalendar.min.css";
@import "../node_modules/codemirror/lib/codemirror.css";
@import "../node_modules/vue-snotify/styles/material.css";
</style>

<style lang="scss">

@import "./assets/scss/style";
@import "/assets/scss/main.scss";
</style>


// WEBPACK FOOTER //
// src/App.vue